
import { defineComponent, ref, onMounted } from 'vue';
import { mapState, useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { document } from 'ionicons/icons';
import { addIcons } from 'ionicons';
import JnBancaDatiSearchParams from '../search/BancaDatiSearchParams.vue';
import * as eventBus from '../../services/event.bus.js';
import { SearchData } from '@/models/search.model';
import { SearchTypes } from '@/models/enums.model';
import { Categories } from '@/models/enums.model';
import { EsService } from '@/services/es.service';
import { Document } from '@/models/document.model';
import JnDoc from '../../components/DocCard.vue';

addIcons({
  document: document,
});

import {
  IonContent,
  IonButtons,
  IonMenuButton,
  IonMenuToggle,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonGrid,
  IonRow,
  IonCol,
  IonText,
  IonFabButton,
  IonFab,
  modalController,
  IonIcon,
  IonLoading,
  IonList,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  alertController,
} from '@ionic/vue';

export default defineComponent({
  name: 'JnBancaDati',
  components: {
    IonPage,
    IonFabButton,
    IonFab,
    IonContent,
    IonIcon,
    IonHeader,
    IonToolbar,
    IonLoading,
    IonList,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    JnDoc,
    /* IonContent,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonMenuToggle,
    IonTitle,
    IonMenuButton,
    IonCard,
    IonCardHeader,
    IonCardTitle,
    IonCardContent,
    IonGrid,
    IonRow,
    IonCol,
    IonText,*/
  },

  setup() {
    const store = useStore();
    const router = useRouter();

    const isDisabled = ref(false);
    const docs = ref([] as Document[]);
    const docsSize = ref();
    const scrollComponent = ref(null);

    const loading = ref(true);
    const timeout = ref(5000);

    const searchData = new SearchData({
      index: process.env.VUE_APP_JURANEWS_INDEXES,
      from: 0,
      size: 10,
      idCategory: [Categories.SINTESI_STORICO],
      withText: true,
      searchInMassime: false
    });

    const pushDocuments = async () => {
      searchData.from = docs.value.length;
      const allDocs = await EsService.getDocs(searchData);
      for (let i = 0; i < allDocs.length; i++) {
        docs.value.push(allDocs[i]);
      }
    };

    const showAlert = async (message: string) => {
      const alert = await alertController.create({
        header: 'Errore',
        message: message,
        buttons: [
          {
            text: 'Riprova',
            role: 'retry',
          },
        ],
      });
      await alert.present();
      const { role } = await alert.onDidDismiss();
      try {
        docs.value = await EsService.getDocs(searchData);
        docsSize.value = await EsService.getDocs(searchData);
      } catch (err) {
        await showAlert(err.message);
      }
    };

    onMounted(async () => {
      loading.value = true;
      try {
        docs.value = await EsService.getDocs(searchData);
        docsSize.value = await EsService.getDocs(searchData);
      } catch (err) {
        loading.value = false;
        showAlert(err.message);
      }
      loading.value = false;
      eventBus.default.$on('reset-results', function(data: string) {
        docs.value = [];
        pushDocuments();
      });
    });

    const loadDocuments = async (ev: CustomEvent) => {
      setTimeout(() => {
        pushDocuments();
        const target = ev.target as HTMLIonInfiniteScrollElement;
        target.complete();

        // App logic to determine if all data is loaded
        // and disable the infinite scroll
        if (docs.value.length == docsSize.value) {
          target.disabled = true;
        }
      }, 500);
    };

    const openSearchParams = async () => {
      const modal = await modalController.create({
        component: JnBancaDatiSearchParams,
        cssClass: 'searchModal',
      });

      eventBus.default.$emit('reset-results');

      modal.present();
      const result = await modal.onDidDismiss();
      if (result.data) {
        const searchData = result.data.value as SearchData;
        store.commit('searchData', searchData);
        eventBus.default.$emit('banca-dati-search-data', searchData);
        router.push('/main/search');
      }
    };

    return {
      openSearchParams,
      loadDocuments,
      docs,
      timeout,
      loading,
      isDisabled,
    };
  },
});
